angular.module('eStories.gift.model', [])

    .service('GiftModel', [
        'WS',
        '$location',
        'ModalsModel',
        'PromoModel',
        function (WS, $location, ModalsModel, PromoModel) {

            var model = this;

            model.promo = PromoModel;

            model.redeemGift = function (token) {
                return WS.callServer('gift/acceptGift', {token: token});
            };

            model.getGiftDetails = function (token) {
                return WS.callServer('gift/giftDetails', {token: token});
            };

            model.assignRedeemCreditsDetails = function (redeemInfo) {
                model.redeemMessage = redeemInfo.message;
                model.redeemSender = redeemInfo.from;
                model.redeemExpirationDate = redeemInfo.expirationDate;
                model.redeemCreditsPlanDescription = redeemInfo.plan.description;
            };

            model.clearGiftRegistration = function () {
                model.giftSenderName = null;
                model.name = null;
                model.email = null;
                model.message = null;
                model.selectedGiftPlan = null;
            };

            model.setSelectedGiftPlan = function (plan) {
                model.selectedGiftPlan = plan;
            };

            model.setPurchasedGiftPlan = function () {
                model.purchasedGiftPlan = model.selectedGiftPlan;
            };

            model.setGiftToken = function (giftToken) {
                model.giftToken = giftToken
            };

            model.removeGiftToken = function () {
                model.giftToken = null;
            };


        }]);
